/**
 * Ajax Forms
 * ======================================
 * - jquery needed
 * - css styles needed
 * - form validation handled via native required
 * - files supported
 * - handled with ajax/forms.php
 */

import $ from "jquery";

$("body").on("submit", ".ajaxForm", function(e) {
	const $this = $(this);
	const $thisParent = $this.closest(".ajaxForm__parent");
	const $messageDiv = $thisParent.find(".ajaxForm__message");
	const $messageSuccess = $thisParent.find(".ajaxForm-success");
	const $messageError = $thisParent.find(".ajaxForm-error");
	const $formSubmit = $this.find("button[type=submit]");

	const formData = new FormData($this[0]);

	// spam honeypot protection
	if (formData.getAll("website").length !== 1) {
		return false;
	}

	// ajax js
	var xhr = new XMLHttpRequest();
	xhr.open("POST", ajaxUrl + "/forms.php", true);

	$formSubmit.addClass("is-loading");

	xhr.send(formData);

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			// success
			if (xhr.status === 200) {
				$(".sideview__container").animate({ scrollTop: 0 }, "slow");

				$messageDiv.removeAttr("hidden");
				$messageSuccess.removeAttr("hidden");
				$formSubmit.removeClass("is-loading");
			}
			// error
			else {
				$messageDiv.removeAttr("hidden");
				$messageError.removeAttr("hidden");
				console.log("ajaxForm error!", xhr);
			}
		}
	};

	e.preventDefault();
});

/**
 *  https://daverupert.com/2017/11/happier-html5-forms/
 * ======================================
 * - add error class to invalid fields
 * - after submit
 */

const inputs = document.querySelectorAll("input, select, textarea");

Array.from(inputs).forEach(function(input) {
	input.addEventListener(
		"invalid",
		event => {
			input.classList.add("error");
		},
		false
	);

	input.addEventListener("blur", function() {
		input.checkValidity();
		input.classList.remove("error");
	});
});
